import { forwardRef, type DetailedHTMLProps, type InputHTMLAttributes } from 'react'

import type { RadioFieldProps } from './types'

const RadioField = forwardRef<
  HTMLInputElement,
  RadioFieldProps & DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
>(({ label, id, ...props }, ref): JSX.Element => {
  return (
    <label
      htmlFor={id}
      className='flex flex-1 items-center px-5 py-4 border border-neutral-200 rounded cursor-pointer'>
      <input
        {...props}
        className='w-4 h-4 text-neutral-600 accent-neutral-900 bg-neutral-100 border-neutral-300 focus:ring-neutral-100 focus:ring-2'
        type='radio'
        id={id}
        ref={ref}
      />
      <span className='m-0 ml-4 text-neutral-900 flex flex-col cursor-pointer'>{label}</span>
    </label>
  )
})

export default RadioField
